import { motion } from "motion/react"
import { Badge } from "@/components/ui/badge"

import type { ReactNode } from "react"

export function PageHero({ eyebrow, title, description }: { eyebrow: string; title: string; description: ReactNode }) {
  return (
    <section className="relative overflow-hidden bg-[#061a1d] px-6 pb-20 pt-36 text-white sm:pb-28 sm:pt-44">
      <div className="surface-grid absolute inset-0 opacity-50" />
      <div className="absolute -right-24 top-16 size-[28rem] rounded-full bg-cyan-300/10 blur-3xl" />
      <div className="absolute -left-20 bottom-0 size-[22rem] rounded-full bg-emerald-300/10 blur-3xl" />
      <motion.div className="relative mx-auto max-w-7xl" initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .7 }}>
        <Badge className="text-emerald-200">{eyebrow}</Badge>
        <h1 className="mt-6 max-w-5xl text-balance text-5xl font-semibold tracking-[-.06em] sm:text-7xl">{title}</h1>
        <p className="mt-7 max-w-3xl text-lg leading-8 text-white/65 sm:text-xl">{description}</p>
      </motion.div>
    </section>
  )
}
